import { SKIN_PROFILE } from "../constants/url";
import { catchErrors } from "../utils/catchErrors";
import { getApiCall } from "../utils/servicesBaseUtil";

export const getSkinProfileApi = ({
  finalCallback,
  successCallback,
  unAunthicatedCallback,
}) => {
  return () => {
    let url = `${SKIN_PROFILE}`;

    getApiCall({ url: url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          if (unAunthicatedCallback) {
            unAunthicatedCallback();
          }
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};
